import { toastErroCarregar } from "./toastErroCarregar";
import { inicializarInternacionalizacao } from "../localizacao/global/global";
import i18next from "i18next";

export async function validarResultado(retorno, callbackSucesso, callbackErro, callbackErroConexao, exibirToastErroConexao = true, exibirToastErroServidor = true) {
    if (retorno.status != 200) {

        if (exibirToastErroConexao) {
            inicializarInternacionalizacao()
            toastErroCarregar(i18next.t('ErroConexaoGenerico'));
        }

        return callbackErroConexao ? callbackErroConexao() : null;
    }

    const resultados = await retorno.json();

    if (resultados.sucesso || resultados.Sucesso) {
        return callbackSucesso(resultados);
    }

    if (exibirToastErroServidor)
        toastErroCarregar(resultados.mensagem);

    return callbackErro ? callbackErro(resultados) : null;



}
